import { gql } from '@apollo/client';

import { lessonWorksheetFragment } from 'approot/lesson/sections/lesson-worksheets/lesson-worksheets.graphql';
import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';

export const lessonAssignFragment = gql`
  fragment LessonAssignFragment on Lesson {
    id
    isAssigned
    assignedData {
      workSheetPages
      vocabularyEnPages
      vocabularyEsPages
      stimulusResourceIds
      activitiesBookmarks {
        version
        sectionIds
      }
    }
  }
`;

export const GET_LESSON_ASSIGN_DATA = gql`
  query GetLessonAssignData($input: GetLessonByIdInput!) {
    getLessonById(input: $input) {
      stimulusResources {
        ...StimulusResource
      }
      ...LessonWorksheetFragment
      ...LessonAssignFragment
    }
  }
  ${lessonWorksheetFragment}
  ${lessonAssignFragment}
  ${stimulusResourceFragment}
`;
